import * as actionTypes from "../constants/typeConstants";

import axios from "axios";

export const getTypes = () => async (dispatch) => {
    const { data } = await axios.get("/api/types");
    dispatch({
        type: actionTypes.GET_TYPES_REQUEST,
        payload: data,
    })
}

export const saveAttributeToCatDoc = (key, val, typeChoosen) => async (dispatch, getState) => {
   const { data } = await axios.post("/api/types/attr", { key, val, typeChoosen }); 
   if (data.typeUpdated) {
       dispatch({
           type: actionTypes.SAVE_ATTR,
           payload: [...data.typeUpdated],
       })
   }
}

export const newType = (type) => async (dispatch, getState) => {
    const cat = getState().getTypes.types;
    const { data } = await axios.post("/api/types", { type });
    if (data.typeCreated) {
        dispatch({
            type: actionTypes.INSERT_TYPE,
            payload: [...cat, data.typeCreated],
        })
    }
}

export const deleteType = (type) => async (dispatch, getState) => {
    const cat = getState().getTypes.types;
    const types = cat.filter((item) => item.name !== type);
    const { data } = await axios.delete("/api/types/" + encodeURIComponent(type));
    if (data.typeDeleted) {
        dispatch({
           type: actionTypes.DELETE_TYPE, 
           payload: [...types],
        })
    }
}